exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".draw-mobile-btn[data-v-5c0d8a4c] {\n  width: 100%;\n  height: 40px;\n}\n.is-invalid[data-v-5c0d8a4c] {\n  color: #dc3545;\n  border: #dc3545 1.2px solid;\n}", ""]);

// exports
